(function() {
  var ShippingDataStore, store,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  ShippingDataStore = (function() {
    function ShippingDataStore() {
      this.sendAttachment = __bind(this.sendAttachment, this);
      this.orderFormUpdated = __bind(this.orderFormUpdated, this);
      $(window).on('orderFormUpdated.vtex', this.orderFormUpdated);
      if (window.vtexjs.checkout.orderForm != null) {
        this.orderFormUpdated(null, window.vtexjs.checkout.orderForm);
      }
    }

    ShippingDataStore.prototype.orderFormUpdated = function(ev, orderForm) {
      return this.orderForm = JSON.parse(JSON.stringify(orderForm));
    };

    ShippingDataStore.prototype.sendAttachment = function(attachment) {
      var addressIsEqual, att, logisticsInfoAreEqual, _ref,
        _this = this;
      att = {};
      att.clearAddressIfPostalCodeNotFound = attachment.clearAddressIfPostalCodeNotFound;
      att.address = JSON.parse(JSON.stringify(attachment.address));
      addressIsEqual = _.isEqual(att.address, (_ref = this.orderForm.shippingData) != null ? _ref.address : void 0);
      if (attachment.logisticsInfo) {
        att.logisticsInfo = _(attachment.logisticsInfo).map(function(li) {
          var shipObj;
          shipObj = _(li).pick("itemIndex", "selectedSla", "deliveryWindow", "tax", "selectedDeliveryChannel");
          shipObj.isScheduled = _.find(li.slas, function(sla) {
            var _ref1;
            if (sla.id === shipObj.selectedSla) {
              return ((_ref1 = sla.availableDeliveryWindows) != null ? _ref1.length : void 0) > 0;
            }
          });
          return shipObj;
        });
        logisticsInfoAreEqual = _.all(att.logisticsInfo, function(li, i) {
          var deliveryWindowIsEqual, existingLI, existingSelectedSLA, _ref1, _ref2;
          existingLI = (_ref1 = _this.orderForm.shippingData) != null ? _ref1.logisticsInfo[i] : void 0;
          existingSelectedSLA = _.find(existingLI.slas, function(s) {
            return s.id === existingLI.selectedSla;
          });
          if ((existingSelectedSLA != null ? (_ref2 = existingSelectedSLA.availableDeliveryWindows) != null ? _ref2.length : void 0 : void 0) > 0 && (li.isScheduled != null)) {
            deliveryWindowIsEqual = _.isEqual(existingSelectedSLA.deliveryWindow, li.deliveryWindow);
          } else {
            deliveryWindowIsEqual = true;
          }
          return li.itemIndex === existingLI.itemIndex && li.selectedSla === existingLI.selectedSla && li.tax === existingLI.tax && deliveryWindowIsEqual;
        });
      }
      if (addressIsEqual && logisticsInfoAreEqual) {
        return $.when(this.orderForm);
      }
      return vtexjs.checkout.sendAttachment('shippingData', att);
    };

    return ShippingDataStore;

  })();

  store = new ShippingDataStore();

  vtex.define('shipping/script/component/ShippingDataStore',[],function() {
    return store;
  });

}).call(this);

